export const transformRequestExportInventoryItems = ({ storeId, filters, emails, template, format }) => {
  return {
    storeId,
    filters,
    params: {
      type: template,
      format,
      emails,
    },
  }
}

export const transformRequestImportInventoryFile = ({ storeId, file }) => {
  const formData = new FormData()
  formData.append('file', file)

  return { storeId, formData }
}

export const transformResponseInventoryImportReport = report => {
  return {
    id: report.id,
    websocket_url: report.websocket_url,
  }
}

const mapInventoryImportFileError = fileError => {
  if (!fileError) return null

  return {
    error_type: fileError.error_type,
    columns: fileError.columns,
  }
}

const mapInventoryImportErrorRow = row => {
  return {
    row_number: row.row_number,
    value: row.value,
  }
}

const mapInventoryImportError = error => {
  return {
    error_type: error.error_type,
    column: error.column,
    count: error.count,
    rows: error.rows.map(mapInventoryImportErrorRow),
  }
}

export const transformResponseInventoryImportResult = result => {
  return {
    processed_rows: result.processed_rows,
    error_rows: result.error_rows,
    file_error: mapInventoryImportFileError(result.file_error),
    errors: result.errors.map(mapInventoryImportError),
  }
}
